export default "__VITE_ASSET__CmXHwLIB__"